// extracted by mini-css-extract-plugin
module.exports = {"settings":"Settings_settings__2E2yN"};